export const SAVE = 'Сохранить';
export const CANCEL = 'Отменить';
export const DELETE_TEXT = 'Удалить';
export const CLOSE = 'Закрыть';
export const FINISH_TASK = 'Задача выполнена';
export const BACK_TO_WORK = 'Вернуть в работу';
export const ADD_TEXT = 'Добавить';
export const CONFIRM_TEXT = 'Подтвердить';
